import { useSyncExternalStore } from 'react'

import { guestTokenStore, ownerTokenStore } from '~store/token'

const useLogInStatus = ({ isGuest = false }: { isGuest?: boolean } = {}) => {
  const { subscribe, getSnapshot } = isGuest ? guestTokenStore : ownerTokenStore
  const isLoggedIn = useSyncExternalStore(subscribe, getSnapshot, getSnapshot)

  return !!isLoggedIn
}

export default useLogInStatus
